export class QuizBase {
    bind(bindingContext, overrideContext) {
        this.bindingContext = bindingContext;
        this.itemSession = bindingContext.itemSession;
    }
}
